import { render, staticRenderFns } from "./ChatBotOverview.vue?vue&type=template&id=647d8166&scoped=true&"
import script from "./ChatBotOverview.vue?vue&type=script&lang=js&"
export * from "./ChatBotOverview.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotOverview.vue?vue&type=style&index=0&id=647d8166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647d8166",
  null
  
)

export default component.exports